<div class="modal__content">
  <div class="confirmation-popup-header">
    <i class="fa-solid fa-file-upload"></i>
    {{ title }}
  </div>

  <div class="confirmation-popup-text">
    <p>{{ description }}</p>
    @if (noteText) {
      <p class="note-text">
        {{ noteText }}
      </p>
    }
    @if (warningText) {
      <p class="text-danger">
        <i class="fas fa-exclamation-triangle"></i>
        {{ warningText }}
      </p>
    }
  </div>

  <div class="file-input-field">
    <input
      #fileInput
      type="file"
      [accept]="acceptedFileTypes"
      (change)="onFileSelected($event)"
      style="display: none"
      />

    <button
      type="button"
      class="btn btn-secondary"
      (click)="openFilePicker()"
      >
      Choose File
    </button>

    <div class="file-display">
      @if (!fileName) {
        <span class="text-muted font-italic">No file chosen</span>
      }
      @if (fileName) {
        <span class="text-dark font-weight-medium" appFsMask>{{ fileName }}</span>
      }
    </div>

    <button
      [disabled]="!selectedFile"
      type="button"
      class="btn btn-light btn-delete"
      [ngClass]="{'btn-delete-active': selectedFile}"
      (click)="clearFile()"
      title="Clear file"
      >
      <i class="fas fa-trash"></i>
    </button>
  </div>
</div>

<div class="modal__footer align-right">
  <button
    type="button"
    class="btn btn-link"
    (click)="onCancel()"
    >
    Close
  </button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="!selectedFile"
    (click)="onUpload()"
    >
    Upload
  </button>
</div>
